import { FormControl, InputLabel } from '@mui/material';

import styled from 'styled-components';

// 1.5rem spacing to make select icon look good
export const StyledFormControl = styled(FormControl)`
  & .MuiSelect-icon {
    font-size: ${props => props.theme.spacing(0.1875)}rem;
  }

  & svg {
    color: ${props => props.theme.palette.secondary.main};
  }

  & .MuiInputLabel-root {
    position: absolute !important;
  }
`;

export const StyledInputLabel = styled(InputLabel)`
  background-color: #fff;
`;

export const TipLabel = styled.div`
  margin-left: auto;
  font-size: 12px;
  color: ${props => props.theme.palette.secondary.main};
  font-weight: 500;

  &:hover {
    cursor: pointer;
  }
`;
